module.exports = __webpack_public_path__ + "img/b930469.jpg";